export const ButtonType = {
    ACTION: "action",
    NUMBER: "number"
}